import { ReactNode } from "react";
import { AuthProvider as OidcProvider } from "react-oidc-context";

import { getUserManager } from "@/auth/userManager";

/**
 * Enveloppe l'appli dans react-oidc-context, avec le `UserManager` unique de
 * ``auth/userManager.ts`` — le même objet que la connexion Touch ID utilise
 * pour poser sa session.
 *
 * Le bootstrap (``main.tsx``) garantit que ``loadRuntimeConfig()`` est résolu
 * avant ce rendu : ``getUserManager()`` peut lire la config de façon synchrone.
 */
export function AuthProvider({ children }: { children: ReactNode }) {
  return (
    <OidcProvider
      userManager={getUserManager()}
      onSigninCallback={() => {
        // Clean the code and the state out of the address bar, KEEPING the history state: the router
        // keeps the position of each entry in it (``idx``), and a navigation held by a form with
        // unsaved changes needs it to put the address back (with ``{}`` it read NaN and the "back"
        // of a held navigation reloaded the page, which is a sign-out).
        window.history.replaceState(window.history.state, document.title, "/");
      }}
    >
      {children}
    </OidcProvider>
  );
}
